import {
    createContext,
    useContext
} from "react";
import type {
    MarkerContextType
} from "./type";

export const MarkerContext = createContext<MarkerContextType | null>(null);

export const useMarkerContext = () => {
    return useContext(MarkerContext);
};
